var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.steps),function(s){return _c('div',{key:s,staticClass:"step-elem",class:s <= _vm.step ? 'on': '',style:({marginRight: s === _vm.steps ? '0px' : '8px'})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }